import React from 'react'
import { uniqueId } from 'lodash'

interface IProps {
  title: string
  value: string
  svgLines: {
    x1: number
    y1: number
    x2: number
    y2: number
    stroke: string
    strokeWidth: number
  }[]
  gradient: string
}

const ResponseCard: React.FC<IProps> = ({ title, value, svgLines, gradient }) => {
  return (
    <div className='card shadow-sm border-0 rounded-lg h-lg-100 position-relative'>
      {/* SVG Graph Background */}
      <svg
        className='position-absolute top-0 start-0 w-100 h-100'
        style={{ zIndex: 0, opacity: 0.3 }}
      >
        {svgLines.map((line, index) => (
          <line
            key={uniqueId()}
            x1={line.x1}
            y1={line.y1}
            x2={line.x2}
            y2={line.y2}
            stroke={line.stroke}
            strokeWidth={line.strokeWidth}
          />
        ))}
      </svg>
      {/* End SVG Graph Background */}

      {/* Shaded Overlay */}
      <div
        className='position-absolute bottom-0 start-0 w-100 h-50'
        style={{ zIndex: 0, background: gradient }}
      ></div>
      {/* End Shaded Overlay */}

      {/* Body */}
      <div
        className='card-body d-flex flex-column justify-content-between'
        style={{ position: 'relative', zIndex: 1 }}
      >
        {/* Icon */}
        <div className='icon-container mb-3'>
          <i className='ki-duotone ki-compass fs-2hx text-primary'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
        </div>
        {/* End Icon */}

        {/* Section */}
        <div className='my-4 text-center'>
          {/* Number */}
          <span className='display-4 text-dark fw-bold'>{value}</span>
          {/* End Number */}

          {/* Formatted Time */}

          {/* End Formatted Time */}

          {/* Follower */}
          <div className='mt-2'>
            <span className='text-muted'>{title}</span>
          </div>
          {/* End Follower */}
        </div>
        {/* End Section */}

        {/* Badge */}
        <div className='badge-container mt-3'>
          <span className='badge badge-light-success d-flex align-items-center'>
            <i className='ki-duotone ki-arrow-up fs-5 text-success me-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
          </span>
        </div>
        {/* End Badge */}
      </div>
      {/* End Body */}
    </div>
  )
}

export default ResponseCard
